import { ContentIntegrationEnum, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { instagramValidators, instagramReelsValidators, instagramStoryValidators } from './instagram'
import { MediaObject } from 'types'
import xValidators from './x'
import facebookValidators from './facebook'
import linkedinValidators from './linkedin'
import wordPressValidators from './word_press'
import tiktokValidators from './tiktok'
import youtubeValidators from './youtube'
import goHighLevelValidators from './go_high_level'
import { ScheduledPostSettings } from 'api/clients/ScheduledPostsClient'
import { DesignChannel } from 'components/NewFileModal/Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'

export interface ValidatorSet {
  validateContent: (content: string) => string[]
  validateFiles: (files: MediaObject[]) => string[]
  validateVideosSize: (files: MediaObject[]) => string[]
  validateImagesSize: (files: MediaObject[]) => string[]
  validateVideosDuration: (files: MediaObject[]) => string[]
  validateVideosAspectRatio: (files: MediaObject[]) => string[]
  validateVideosFormat: (files: MediaObject[]) => string[]
  validateVideosCount: (files: MediaObject[]) => string[]
  validateVideosWidth?: (files: MediaObject[]) => string[]
  validateVideosFrameRate?: (files: MediaObject[]) => string[]
  validatePostSettings: (settings?: ScheduledPostSettings) => string[]
}

const mailchimpValidators: ValidatorSet = {
  validateContent: (content: string) => {
    if (content.length > 10000) {
      return ['Content exceeds 10000 characters']
    }
    return []
  },
  validateFiles: () => [],
  validateVideosSize: () => [],
  validateImagesSize: () => [],
  validateVideosDuration: () => [],
  validateVideosAspectRatio: () => [],
  validateVideosFormat: () => [],
  validateVideosCount: () => [],
  validatePostSettings: () => [],
}

const wixValidators: ValidatorSet = {
  validateContent: () => [],
  validateFiles: () => [],
  validateVideosSize: () => [],
  validateImagesSize: () => [],
  validateVideosDuration: () => [],
  validateVideosAspectRatio: () => [],
  validateVideosFormat: () => [],
  validateVideosCount: () => [],
  validatePostSettings: () => [],
}

const shopifyValidators: ValidatorSet = {
  validateContent: () => [],
  validateFiles: () => [],
  validateVideosSize: () => [],
  validateImagesSize: () => [],
  validateVideosDuration: () => [],
  validateVideosAspectRatio: () => [],
  validateVideosFormat: () => [],
  validateVideosCount: () => [],
  validatePostSettings: () => [],
}

const platformValidators: Record<ContentIntegrationEnum, ValidatorSet> = {
  instagram: instagramValidators,
  x: xValidators,
  facebook: facebookValidators,
  linkedin: linkedinValidators,
  word_press: wordPressValidators,
  tiktok: tiktokValidators,
  youtube: youtubeValidators,
  mailchimp: mailchimpValidators,
  go_high_level: goHighLevelValidators,
  wix: wixValidators,
  shopify: shopifyValidators,
}

const getChannelOverrides = (channel?: ChannelType | DesignChannel) => {
  switch (channel) {
    case DesignChannel.InstagramReel:
      return instagramReelsValidators
    case DesignChannel.InstagramStory:
      return instagramStoryValidators
    default:
      return null
  }
}

const getPlatformValidators = (platform: ExternalIntegrationEnum, channel?: ChannelType | DesignChannel | null) => {
  const channelOverrides = getChannelOverrides(channel ?? undefined)

  if (channelOverrides) {
    return channelOverrides
  }

  if (platform in platformValidators) {
    return platformValidators[platform as keyof typeof platformValidators]
  }

  return null
}

export { getPlatformValidators }
